<template>
	<ui-root :part="{ type: 'interface'}" :data="{}" :errs="errors">
	<div class="scroll-frame">
		<div class="scroll-frame-head">
			<div class="head-title">
				<div class="fd-flow">
					<sym-icon name="relation-pair" />
					<span class="fd-text">{{msg("form.resolveMerge")}}</span>
				</div>
				<div v-if="errors && errors.length>0">
					<api-error level="SEVERE" :message="msg('err.formContainsError')"></api-error>
				</div>
			</div>
		</div>	
		<div class="scroll-frame-body">
			<div v-if="loaded">
				<table class="agenda">
				<thead>
					<tr>
						<th><span class="fd-text">{{msg("merge.fields")}}</span>:</th>
						<th><span class="fd-text">{{msg("merge.winObject",consolidator.winner)}}</span></th>
						<th><span class="fd-text">{{msg("merge.mergedObject")}}</span></th>
						<th><span class="fd-text">{{msg("merge.lostObject",consolidator.looser)}}</span></th>
					</tr>
				</thead>
				<tbody>
					<template v-for="(field, index) in displayFields" :key="field.definition.property">
						<consolidable-row :data="field" v-model="dataResult" :index="index"  @remove-conflict="removeConflict" />
					</template>
				</tbody>
				</table>
			</div>
		</div>
		<div class="scroll-frame-tail">	
			<div class="tablepager">
				<div class="tablepager-content">
					<span class="pagercontrols"></span>
					<span class="tablesetting" >
						<button type="button" class="fd-button" :disabled="hasConflict" @click="resolveMerge">{{msg("selector.consolidate")}}</button>
					</span>
				</div>
			</div>
		</div>
	</div>
	</ui-root>
</template>

<script setup lang="ts">
import {onMounted, ref, reactive, computed, provide} from "vue";
import {injectEnv} from "@fd/Environment";
import type {ErrorMap} from "@fd/PartInjectKeys";
import {useRouter,useRoute} from "vue-router";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import type {Consolidator, ConsolidableDataItem} from "@t/agenda/Consolidator.ts";
import {msg} from "@/i18n/Message";
import {go} from "@/router/Router.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ConsolidableRow from "@/vue/agenda/ConsolidableRow.vue";
import ApiError from "@/fd/helpers/ApiError.vue";
import UiRoot from "@fd/containers/UiRoot.vue";
	
const props = defineProps<{
	urlPart: string
}>();	
	
const env = injectEnv();
const navStore = useNavigationStore();

const loaded = ref<boolean>(false);
const errors = reactive<ErrorMap>([]);
const consolidator = ref<Consolidator|null>(null);
const dataResult = ref({});

function resolveMerge(): void {
	errors.length = 0;
	env.net.fetch("api/"+props.urlPart+"/merge", "POST", dataResult.value)
		.then((response) => {
			if (response.ok) {
				//router.back();
				//console.log("winner:"+ consolidator.value.looser);
				navStore
					.removeFromStacker({path:"editParty.do",attributes: {id:consolidator.value.looser}})
					.then(() => {
							go(navStore.previousPagePathFromStacker());
						});
				
			} else {
				response.json()
					.then((data) => {
						if (Array.isArray(data.problems)) {
							for (let problem of data.problems) {
								console.log("problem:"+JSON.stringify(problem));
								errors.push(problem);
							}
							//reload Form
							loadData();
						}		
				});
				//reject(false); ??
			}
		});
}

const hasConflict = computed(() => {
	return !consolidator.value || (consolidator.value.conflicts && consolidator.value.conflicts.length>0);
});

const displayFields = computed<ConsolidableDataItem[]>(() => {
		return consolidator.value.fields?consolidator.value.fields.filter(field => field.display):[];
	});

function loadData() {
	let endpoint = "api/"+props.urlPart+"/merge";
	return env.net.fetch(endpoint)
			.then((result) => result.json())
			.then(receivedData);
}

function receivedData(data):void {
	consolidator.value = data.consolidator;
	dataResult.value = data.dataResult;
	loaded.value = true;
	//console.log("consolidator conflicts:"+JSON.stringify(consolidator.value.conflicts));
	//console.log("consolidator:"+JSON.stringify(consolidator.value));
	console.log("dataResult:"+JSON.stringify(dataResult.value));
}

function removeConflict(conflict: string):void {
	consolidator.value.conflicts = consolidator.value.conflicts.filter(item => item !== conflict);
}
navStore.defineMenu((mb) => mb.standardMenu());

onMounted(() => {
	navStore.forward(env.msg("selector.consolidate"));
	loadData();
});
</script>

<style>

</style>
